export const TITRES = {
    'autorisation-detention-arme': `Demander une autorisation d'acquisition et de détention d'armes, d'éléments d'armes et de munitions`,
};

export const LABELS = {
    'autorisation-detention-arme': `Demander une autorisation d'acquisition et de détention d'armes`,
    'autorisation-detention-arme-metier-asso': `Déposer une demande d'autorisation`,
};

export const TYPE_DEMARCHE = {
    'autorisation-detention-arme': "Autorisation d'acquisition et de détention",
};

export const STATUT_TITRE_DETENTION = {
    nouveau: `Nouveau`,
    'a-completer': `A compléter`,
    complete: `En cours`,
    'verification-des-pieces': `En cours`,
    'enquete-en-cours': `En cours`,
    'en-attente-de-decision': `En cours`,
    refuse: `En cours`,
    'a-dessaisir': `Invalide`,
    valide: `Valide`,
    abandonne: `Invalide`,
    invalide: `Invalide`,
    'en-cours': 'En cours',
};

// STATUS
export const STATUT_NOUVEAU = 'nouveau';
export const STATUT_A_COMPLETER = 'a-completer';
export const STATUT_COMPLETEE = 'complete';
export const STATUT_VERIFICATION_DES_PIECES = 'verification-des-pieces';
export const STATUT_EN_COURS = 'en-cours';
export const STATUT_ENQUETE_EN_COURS = 'enquete-en-cours';
export const STATUT_EN_ATTENTE_DE_DECISION = 'en-attente-de-decision';
export const STATUT_REFUSEE = 'refuse';
export const STATUT_A_DESSAISIR = 'a-dessaisir';
export const STATUT_INVALIDE = 'invalide';
export const STATUT_VALIDE = 'valide';
export const STATUT_ABANDONNE = 'abandonne';

export const STATUTS_NON_FINAUX = [
    STATUT_NOUVEAU,
    STATUT_A_COMPLETER,
    STATUT_COMPLETEE,
    STATUT_VERIFICATION_DES_PIECES,
    STATUT_ENQUETE_EN_COURS,
    STATUT_EN_ATTENTE_DE_DECISION,
    STATUT_REFUSEE,
];

export const STATUTS_FINAUX = [
    STATUT_ABANDONNE,
    STATUT_A_DESSAISIR,
    STATUT_VALIDE,
    STATUT_INVALIDE,
];

// Transition
export const TRANSITION_COMPLETER_PJ = 'completer_pj';

export const TITRES_PIECES_JOINTES = {
    piecesIdentite: 'CNI, passeport ou titre de séjour',
    justificatifDomicile: 'Justificatif de domicile',
    acteNaissance: "Extrait de l'acte de naissance",
    licenceTir: 'Licence de Tir',
    licenceBallTrap: 'Licence de Ball Trap',
    licenceSki: 'Licence de Ski',
    certificatMedicalPsychiatrique: 'Certificat médical',
    avisPrealableFftir: 'Avis préalable délivré par la Fédération Française de tir',
    attestationCompetiteur: 'Attestation de compétition FFTir',
    attestationSuiviFormationTir: 'Attestation de formation aux règles de sécurité',
    justificatifLieuExercice: 'Justificatif du lieu d’exercice',
    declarationCaracteristiquesArmes:
        'Déclaration des caractéristiques des armes et matériels de guerre',
    permisDeChasse: 'Permis de chasse',
    justificationSeancesTir: 'Justification de participation à des séances de tir',
    formationSecuriteTir: 'Attestation de formation initiale',
    ficheCaracteristiquesArmes: 'Fiche descriptive des armes',
    certificatDeResidence: 'Certificat de résidence',
    piecesJustificativesMusee:
        'Pièces justificatives de l’identité et de la qualité des représentants, de leur siège et de leur activité',
    rapportMusee:
        'Rapport sur les moyens de protection contre le vol ou les intrusions et sur les modalités de conservation du matériel',
    exploitantTirForain:
        'Déclaration précisant le nombre et la nature des armes mises en service au moyen de leurs marques, modèles, numéros et calibres prévue à l’article R.312-5 5°',
    theatreSocieteProduction:
        'Déclaration signée attestant que les armes détenues, désignées par leurs marques, modèles, numéros de série et calibres, ont été rendues inaptes au tir des munitions à balle ou à grenaille',
    nuisiblesParcsZoologiquesEssaisIndustrielsStatus: 'Copie des statuts de la personne morale',
    nuisiblesParcsZoologiquesEssaisIndustrielsPieceIdentite:
        'Copie de la pièce justificative de l’identité du représentant légal en cours de validité',
    nuisiblesParcsZoologiquesEssaisIndustrielsCertificatMedical:
        'Certificat médical datant de moins d’un mois attestant que l’état de santé physique et psychique du représentant légal n’est pas incompatible avec la détention d’armes',
    autorisationDetentionArme: 'Autorisation de détention d’arme',
    associationFederationTirSportifActeOfficielMinistere:
        'Acte officiel de délégation accordée par le ministère chargé des sports',
    associationFederationTirSportifJustificatifRepresentantLegal:
        'Pièce justificative du mandat légal du responsable légal',
    associationFederationTirSportifEtudeSurete:
        'Étude de sûreté décrivant les mesures prévues à l’article R.314-8',
    associationFederationDeclarationComplementaire: 'Déclaration complémentaires',
    // Pièces jointes du responsable légal
    acteNaissanceResponsableLegal: 'Acte de naissance du responsable légal',
    piecesIdentiteResponsableLegal: "Pièces d'identité du responsable légal",
    justificatifDomicileResponsableLegal: 'Justificatif de domicile du responsable légal',
    preuveAutoriteParentale: "Preuve de l'autorité parentale",
    certificatHonneur: "Certificat sur l'honneur du responsable légal",
};

export const MOTIF_DEMANDE_PIECES_JOINTES = {
    illisible: `Illisible`,
    justificatifTropAncien: `Justificatif trop ancien`,
    pieceManquante: `Pièce manquante`,
    mauvaisDocument: `Mauvais document`,
    invalide: `Invalide`,
};
